import { Box, Grid, Typography } from "@mui/material";

import { grey } from "@mui/material/colors";
import { useEffect, useState } from "react";

import RegisterAccountType from "./RegisterAccountType";
import RegisterBusinessForm from "./RegisterBusinessForm";
import RegisterIndividualForm from "./RegisterIndividualForm";

import file from "./blacklist.txt";
import _ from "lodash";

export default function Register() {
  const [verification, setVerification] = useState<string | null>(null)
  const [confirmedType, setConfirmedType] = useState<string | null>(null)
  const [blacklists, setBlacklists] = useState<string[]>([])

  const registerFormContext = {
    verification,
    setVerification,
    confirmedType,
    setConfirmedType,
    blacklists
  }

  async function fetchBlacklistFileContent() {
    try {
      const response = await fetch(file)
      const content = await response.text()

      const items = _.uniq(content?.toString()?.split("\n")?.toString()?.split(","))

      setBlacklists(items)
    } catch (exeption) {
      // nothing to do
    }
  }

  useEffect(() => {
    fetchBlacklistFileContent()
  }, [])

  return (
    <Box sx={{ bgcolor: "#F8F8F8", height: "100vh" }}>
      <Grid container direction="row" justifyContent="center" alignItems="center" sx={{ height: "inherit" }}>
        <Grid item md={3} xs={12} sx={{ p: 2 }}>
          <Box sx={{ mb: 2, display: "flex", justifyContent: "center" }}>
            <img src="/assets/icon.png" width={50} height={50} />
          </Box>
          <Box sx={{ mb: 2, p: 5, borderRadius: 2, bgcolor: "white" }}>
            {confirmedType && <Typography fontSize={13} sx={{ mb: 0.25 }}>— {confirmedType}</Typography>}
            <Typography fontWeight={600} sx={{ color: grey[900] }}>Sign up to VNETWORK JSC</Typography>
            <Box sx={{ mt: 3 }}>
              {confirmedType === 'individual' ? (
                <RegisterIndividualForm {...registerFormContext} />
              ) : confirmedType === 'business' ? (
                <RegisterBusinessForm {...registerFormContext} />
              ) : (
                <RegisterAccountType {...registerFormContext} />
              )}
            </Box>
          </Box>
          <Typography fontSize={14} color="#9b9b9b">© 2013 VNETWORK JSC. All Rights Reserved</Typography>
        </Grid>
      </Grid>
    </Box>
  )
}